import {Navigate, Outlet} from "react-router-dom";
import {useEffect, useState} from "react";
import {ensureValidSession} from "../../services/authService";

type GuardState = "authenticated" | "not_authenticated";

/**
 * Компонент, который редиректит авторизованных пользователей на dashboard.
 * Используется для страниц, доступных только неавторизованным пользователям (например, /login).
 */
export function RedirectIfAuth() {
    const [status, setStatus] = useState<GuardState>("not_authenticated");

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                await ensureValidSession();
                if (mounted) {
                    setStatus("authenticated");
                }
            } catch {
                // Пользователь не авторизован, показываем страницу
                // Состояние уже "not_authenticated", ничего не меняем
            }
        })();

        return () => {
            mounted = false;
        };
    }, []);

    if (status === "authenticated") {
        return <Navigate to="/dashboard" replace />;
    }

    return <Outlet />;
}



